import { Injectable, OnDestroy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { AsyncSubject, zip as observableZip } from "rxjs";
import { SystemConfigurationValues } from "../../../common/configuration/services/system.configuration.utils";
import { UserContextService } from "../../user.context/services/user.context.service";
import { AuthLevel } from '../interfaces/iuser.permissions';
import { UserPermissions } from './user.permissions';

//export let UserPermssionsToken = new InjectionToken("user.permissions");

export interface IUserPermissionsService{
	supportPermissions():boolean;
	permissionsReadyObservable();
	getPermissions(permission: string): AuthLevel ;
	hasPermissions(permission: string, requiredLevel: AuthLevel) : boolean;
	getPermissionsList() : Array<string>;
}


@Injectable({providedIn: 'root'})
export class PatientUserPermissionsService implements IUserPermissionsService {

	permissionsReadyObservable(){
		return null;
	}
	getPermissions(permission: string): AuthLevel {
		return AuthLevel.Hidden;
	}
	hasPermissions(permission: string, requiredLevel: AuthLevel) : boolean{
		return requiredLevel===AuthLevel.Hidden;
	}
	getPermissionsList() : Array<string>{
		return [];
	}

	supportPermissions(): boolean {
		return false;
	}
}

@UntilDestroy()
@Injectable({ providedIn: 'root' })
  export class UserPermissionsService implements IUserPermissionsService,OnDestroy{
	public data: UserPermissions;
	private permissionsReadySubject = new AsyncSubject();

	constructor(private usr: UserContextService,
				private scv: SystemConfigurationValues
	) {
		observableZip(this.usr.permissionsObservable(), this.scv.authenticatedSystemConfigurationReadyObservable()
		).pipe(untilDestroyed(this)).subscribe(p => {
			this.data = new UserPermissions(p[0], this.scv.getBoolean('ApplySecurityByActiveRole', false));
			this.permissionsReadySubject.next(null);
			this.permissionsReadySubject.complete();
		});
	}

	ngOnDestroy(): void {

	}

	public permissionsReadyObservable(){
		return this.permissionsReadySubject.asObservable();
	}

	public getPermissions(permission: string): AuthLevel {
		return this.data.highestPermission(permission, this.usr.getCachedUserContext().roleGroupKey);
	}

	public hasPermissions(permission: string, requiredLevel: AuthLevel) : boolean{
		let availPermission = this.data.highestPermission(permission, this.usr.getCachedUserContext().roleGroupKey);
		return ((availPermission != null) && (availPermission <= requiredLevel));
	}

	public getPermissionsList() : Array<string> {
		return this.data.getPermissionsList();
	}

	supportPermissions(): boolean {
		return true;
	}
}
